import 'remixicon/fonts/remixicon.css';
import { Route, Switch, Link } from "react-router-dom";
import { Student } from '../../store/viewmodels/StudentViewModel';
import StudentInfo from './StudentInfo';

interface TeacherStudentsProps {
    path: string,
    students: Student[],
    used: boolean
}

function TeacherStudents(props: TeacherStudentsProps): JSX.Element {
    let path = props.used ? props.path + '/usedKeys/' : props.path + '/unusedKeys/';

    return (
        <div className="flex">
            <div className="border-r">
                <StudentList students={props.students} path={path} used={props.used} />
            </div>
            <div>
                <Switch>
                    <Route path={`${path}:studentId`}>
                        <StudentInfo used={props.used} />
                    </Route>
                </Switch>
            </div>
        </div>
    );
}

interface StudentListProps {
    students: Student[],
    path: string,
    used: boolean
}

function StudentList(props: StudentListProps): JSX.Element {
    let items: JSX.Element[] = [];

    for (let i: number = 0; i < props.students.length; i++) {
        items.push(<StudentListItem key={"student" + props.students[i].id} index={i} student={props.students[i]} path={props.path} used={props.used} />)
    }

    return (
        <div className="bg-white">
            <ul className="divide-y divide-gray-200 border-b">
                {items}
            </ul>
        </div>);
}


interface StudentListItemProps {
    index: number,
    student: Student,
    path: string,
    used: boolean
}

function StudentListItem(props: StudentListItemProps): JSX.Element {

    
    let name = props.student.identification === "" ? props.student.username : props.student.identification.toUpperCase();
    let group = props.student.group === "" ? "" : "Ryhmä: " + props.student.group ;
    let logo = props.used ? "ri-ghost-2-fill" : "ri-key-line";

    return (
        <li>
            <Link to={props.path + props.student.id} className="block group hover:bg-teal-50">
                <div className="flex items-center px-1 py-1 sm:px-6">
                    <div className="min-w-0 flex-1 flex items-center">
                        <div className="flex-shrink-0">
                            <i className={"text-gray-700 group-hover:text-teal-500 text-3xl " + logo}></i>
                        </div>
                        <div className="min-w-0 flex-1 px-4">
                            <p className="text-sm font-medium text-teal-600 truncate">{name}</p>
                            <p className="text-sm font-medium text-teal-600 truncate">{group}</p>
                        </div>
                    </div>
                </div>
            </Link>
        </li>
    );
}

export default TeacherStudents;